var map = {
	"./content/journey1/modular-map-icons/ForkliftsCars-selected.png": 34,
	"./content/journey1/modular-map-icons/ForkliftsCars.png": 35,
	"./content/journey1/modular-map-icons/MerseySide Icons/DataDashboardSmoke_001.png": 36,
	"./content/journey1/modular-map-icons/MerseySide Icons/Freight/F1.png": 37,
	"./content/journey1/modular-map-icons/MerseySide Icons/Freight/F2.png": 38,
	"./content/journey1/modular-map-icons/MerseySide Icons/Freight/F3.png": 39,
	"./content/journey1/modular-map-icons/MerseySide Icons/Freight/F4.png": 40,
	"./content/journey1/modular-map-icons/MerseySide Icons/Freight/F5.png": 41,
	"./content/journey1/modular-map-icons/MerseySide Icons/Freight/F6.png": 42,
	"./content/journey1/modular-map-icons/MerseySide Icons/HydrogenGeneration_001.png": 43,
	"./content/journey1/modular-map-icons/MerseySide Icons/MicroGrid_001.png": 44,
	"./content/journey1/modular-map-icons/MerseySide Icons/Passenger/P1.png": 45,
	"./content/journey1/modular-map-icons/MerseySide Icons/Passenger/P2.png": 46,
	"./content/journey1/modular-map-icons/MerseySide Icons/Passenger/P4.png": 47,
	"./content/journey1/modular-map-icons/MerseySide Icons/Passenger/P5.png": 48,
	"./content/journey1/modular-map-icons/MerseySide Icons/Passenger/P6.png": 49,
	"./content/journey1/modular-map-icons/MerseySide Icons/ShipCargo_001.png": 50,
	"./content/journey1/modular-map-icons/MerseySide Icons/Tourist/TouristLine.png": 51,
	"./content/journey1/modular-map-icons/MerseySide Icons/pin.png": 52,
	"./content/journey1/modular-map-icons/MerseySide Icons/pinhover.png": 53,
	"./content/journey1/modular-map-icons/PinGreen.png": 54,
	"./content/journey1/modular-map-icons/PinNavy.png": 55,
	"./content/journey1/modular-map-icons/PowerStorage-selected.png": 56,
	"./content/journey1/modular-map-icons/PowerStorage.png": 57,
	"./content/journey1/modular-map-icons/ShipsRoRoRamps-selected.png": 58,
	"./content/journey1/modular-map-icons/ShipsRoRoRamps.png": 59,
	"./content/journey1/modular-map-icons/T1-selected.png": 60,
	"./content/journey1/modular-map-icons/T1.png": 61,
	"./content/journey1/modular-map-icons/T2-selected.png": 62,
	"./content/journey1/modular-map-icons/T2.png": 63,
	"./content/journey1/modular-map-icons/T3-selected.png": 64,
	"./content/journey1/modular-map-icons/T3.png": 65,
	"./content/journey1/modular-map-icons/T4-selected.png": 66,
	"./content/journey1/modular-map-icons/T4.png": 67,
	"./content/journey1/modular-map-icons/T4Alt-selected.png": 68,
	"./content/journey1/modular-map-icons/T4Alt.png": 69,
	"./content/journey1/modular-map-icons/T5-selected.png": 70,
	"./content/journey1/modular-map-icons/T5.png": 71,
	"./content/journey1/modular-map-icons/T6-selected.png": 72,
	"./content/journey1/modular-map-icons/T6.png": 73,
	"./content/journey2/modular-map-icons/P1.png": 74,
	"./content/journey2/modular-map-icons/P2.png": 75,
	"./content/journey2/modular-map-icons/P3.png": 76,
	"./content/journey2/modular-map-icons/P4.png": 77,
	"./content/journey2/modular-map-icons/P5.png": 78,
	"./content/journey2/modular-map-icons/P6.png": 79,
	"./content/journey3/modular-map-icons/F1.png": 80,
	"./content/journey3/modular-map-icons/F2.png": 81,
	"./content/journey3/modular-map-icons/F3.png": 82,
	"./content/journey3/modular-map-icons/F4.png": 83,
	"./content/journey3/modular-map-icons/F5.png": 84,
	"./content/journey3/modular-map-icons/F6.png": 85,
	"./content/logos/Catapult.png": 13,
	"./content/logos/Mersey_Maritime.png": 14,
	"./content/logos/RHDHV.png": 15,
	"./content/main/MerseySidePort.png": 4,
	"./content/multiple/use-case-icons/clean-shipping-discounts-icon.png": 86,
	"./content/multiple/use-case-icons/green-corridors-icon.png": 87,
	"./content/multiple/use-case-icons/port-emission-taxation-icon.png": 88,
	"./content/pins/PinNavy.png": 89,
	"./content/pins/pin-098CB3.png": 16,
	"./content/pins/pin-5FBCA2.png": 17,
	"./content/pins/pin-E8ADC7.png": 18,
	"./content/pins/pin-blue.png": 19,
	"./content/pins/pin-green.png": 20,
	"./content/pins/pin-hover.png": 21,
	"./content/pins/pin-navy.png": 22,
	"./content/pins/pin-orange.png": 23,
	"./content/pins/pin-purple.png": 24,
	"./content/pins/pin.png": 90,
	"./content/routes/FerryPassenger.png": 8,
	"./content/routes/Freight.png": 9,
	"./content/routes/Tourist.png": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;